export const NUMBER_OF_CARS_PER_PAGE = 11;
export const A_Z = 'A_Z';
export const Z_A = 'Z_A';
export const CHEAP_FIRST = 'CHEAP_FIRST';
export const EXPENSIVE_FIRST = 'EXPENSIVE_FIRST';
export const NEWEST_FIRST = 'NEWEST_FIRST';

export const GRID_STYLE = 'grid';
export const LIST_STYLE = 'list';

export const CARS_STATE = 'CARS_STATE';
export const CAR_BRAND_STATE = 'CAR_BRAND_STATE';
export const PRICE_STATE = 'PRICE_STATE';

export const None = 'None';

export const MIN_PRICE = 1000;
export const MAX_PRICE = 50000;

export const DELAY = 500;

export const ANOTHER = 'Another';

export const sscomDefaultDescriptionLv = `
- Pierādāms automašīnas nobraukums ... km.

- Pilnā servisa vēsture no oficiāla dīlera(var pārbaudīt pēc VIN numura).

- Visas mūsu automašīnas ir pārbaudītās un sagatavotas tehniskai apskatei, ka arī turpmākai lietošanai.

- Mums ir liels auto piedāvājums (vairāk par 100 auto).

- Automašīnas var apskatīt pēc adreses: Rīga, Augusta Deglava ielā 65.

- Ja nepieciešams līzings, to var noformēt uz vietas, nekur nav jāskrien.

- Izdevīgie līzinga risinājumi(arī strādājošiem ārzemēs, kā arī bez oficiāliem ienākumiem).

- Jūsu vecais auto var segt līzinga pirmo iemaksu vai daļējo samaksu par jauno automašīnu(maiņa).

- Apmaksa pēc automašīnas reģistrācijas un tehniskas apskates.Tehniskā apskate garantētā.

- Cienīgs piedāvājums.Ir vērts atbraukt un apskatīt.`;

export const sscomDefaultDescriptionRu = `
- Подтвержденный пробег ... км.

- Полная сервисная история от официального дилера(можно проверить по VIN номеру).

- Все наши авто проверены и подготовлены к ТО, а также к дальнейшей эксплуатации.

- У нас большой выбор авто(более 100).

- Авто можно посмотреть по адресу: ул.Августа Деглава 65, Рига.

- При необходимости, на месте можно оформить лизинг.

- Привлекательные варианты лизинга(также работающим за границей и без официальных доходов).

- Ваш старый авто может быть засчитан, как первый взнос по лизингу или частичная оплата за новый авто.

- Оплата после ТО и регистрации авто.ТО гарантируем.

- Достойное предложение.Стоит приехать и посмотреть.`;

const { dictionary } = startup;

export const leaseSlides = [
  {
    title: dictionary.LeaseSlide1Title,
    url: 'url(./media/content/slider-lease/1.png)',
  },
  {
    title: dictionary.LeaseSlide2Title,
    url: 'url(./media/content/slider-lease/2.png)',
  },
];

export const leaseSlidesCatalogGrid = [
  {
    title: dictionary.LeaseSlide1Title,
    url: 'url(../../media/content/catalog-lease/grid-1.png)',
  },
  {
    title: dictionary.LeaseSlide2Title,
    url: 'url(../../media/content/catalog-lease/grid-2.png)',
  },
];

export const leaseSlidesCatalogList = [
  {
    title: dictionary.LeaseSlide1Title,
    url: 'url(../../media/content/catalog-lease/list-1.png)',
  },
  {
    title: dictionary.LeaseSlide2Title,
    url: 'url(../../media/content/catalog-lease/list-2.png)',
  },
];
